/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * comment on and justification of performance
 */
export type EvalDimRatingComment = string | null;
